import { PaymentAdapter } from '../infra/adapters/payment.adapter';
import { createPaymentService } from '../application/services/PaymentService';
import { RazorpayAdapter } from '../infra/adapters/razorpay.adapter';
import { baseBuild } from '@/core/services/network/config/baseBuild';
import type { AppDispatch } from '@/app/store/store';

export function paymentBuild(dispatch: AppDispatch) {
  return baseBuild(
    (dispatch) => new PaymentAdapter(dispatch),
    (repo) => {
      const razorpayAdapter = new RazorpayAdapter();
      return createPaymentService(repo, razorpayAdapter, razorpayAdapter);
    },
    dispatch
  );
}
